import { FILLWORD_LOADED, FILLWORD_UNLOAD } from '@src/actions';

export default (state = {}, action) => {
  switch (action.type) {
    case FILLWORD_LOADED:
      return {
        ...state,
        FillWord: {
          rows: action.payload.fillword,
          words: action.payload.words.map((row) => {
            return row.map(c => {
              return c.join('')
            }).join('');
          }),
        },
      };
    case FILLWORD_UNLOAD:
      return {
        ...state,
        FillWord: null,
      };
    default:
      return state;
  }
};